<template>
    <div class="row" style="margin-top:20px">
        <router-link :to="{name:'home-view'}">
            <img src="../assets/logo_genom23.png">
        </router-link>

        <form>
            <router-link class="btn btn-success" :to="{name:'register-view'}" id="register_collection_set_link">
                {{$t('register_button_label')}}
            </router-link>
            <router-link v-if="!isLoggedIn" class="btn btn-success" :to="{name:'login-view'}" id="login_link">
                {{$t('sign_in_button_label')}}
            </router-link>
            <span v-if="isLoggedIn" class="btn btn-success">{{$t('signed_in_as')}} {{user.registration_code}} (<button
                    class="btn btn-sm"
                    @click="logout">{{$t('sign_out')}}</button>)</span>
        </form>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import {HANDLE_LOGOUT, CHANGE_LANGUAGE} from "../store/actions";

    export default {
        name: "TopBar",
        computed: {
            ...mapGetters(['isLoggedIn', 'userId', 'expireTime', 'user'])
        },
        methods: {

        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/TopBar.vue